import { render, staticRenderFns } from "./SeminarInfo.vue?vue&type=template&id=afd1ebd6&scoped=true"
import script from "./SeminarInfo.vue?vue&type=script&lang=js"
export * from "./SeminarInfo.vue?vue&type=script&lang=js"
import style0 from "./SeminarInfo.vue?vue&type=style&index=0&id=afd1ebd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd1ebd6",
  null
  
)

export default component.exports